<template>
    <div class="vue-rental-option-modal-wrapper">
        <div class="modal-header d-flex justify-content-between align-items-start px-4 pt-4">
                <h3 class="modal-title mb-4">Persoonlijke gegevens aanpassen</h3>

                <button class="close-button mt-1" @click="$modal.close()">
                    {{ translations.closeText }}
                </button>
            </div>

            <div class="modal-body px-4 pb-4">
                <div class="">
                    <div v-if="successMessage" class="alert alert-success">
                        {{ successMessage }}
                    </div>
                    <div v-if="errorMessage" class="alert alert-danger">
                        {{ errorMessage }}
                    </div>

                    <form @submit.prevent="handleSubmit" v-if="!successMessage">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="titel">Titel</label>
                                    <select id="titel" v-model="form.Titel" class="form-control">
                                        <option value="dhr">Dhr.</option>
                                        <option value="mevr">Mevr.</option>
                                        <option value="anders">anders</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="voornaam">Voornaam *</label>
                                    <input type="text" id="voornaam" v-model="form.Voornaam" class="form-control" required>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="achternaam">Achternaam *</label>
                                    <input type="text" id="achternaam" v-model="form.Achternaam" class="form-control" required>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="geboortedatum">Geboortedatum</label>
                                    <datepicker 
                                        id="geboortedatum" 
                                        v-model="form.Geboortedatum" 
                                        :language="nl" 
                                        format="dd-MM-yyyy"
                                        input-class="form-control"
                                        placeholder="31-12-2000"
                                        :monday-first="true"
                                        :bootstrap-styling="false"
                                    ></datepicker>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="telefoon">Telefoonnummer</label>
                                    <input type="text" id="telefoon" v-model="form.Telefoon" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="straat">Straat</label>
                                    <input type="text" id="straat" v-model="form.Straat" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="huisnummer">Huisnummer</label>
                                    <input type="text" id="huisnummer" v-model="form.Huisnummer" class="form-control">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="postcode">Postcode</label>
                                    <input type="text" id="postcode" v-model="form.Postcode" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="stad">Stad</label>
                                    <input type="text" id="stad" v-model="form.Stad" class="form-control">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="land">Land</label>
                                    <select id="land" v-model="form.Land" class="form-control">
                                        <option value="NL">Nederland</option>
                                        <option value="BE">België</option>
                                        <option value="DE">Duitsland</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="form-group mt-3">
                            <div class="custom-control custom-checkbox d-flex align-items-center">
                                <input type="checkbox" class="custom-control-input" id="nieuwsbrief" v-model="form.Nieuwsbrief">
                                <label class="custom-control-label ml-2" for="nieuwsbrief">Ik wil graag de nieuwsbrief ontvangen</label>
                            </div>
                        </div>

                        <div class="modal-actions">
                            <button type="button" class="btn btn-outline" @click="$modal.close()">Annuleren</button>
                            <button type="submit" class="btn btn-primary" :disabled="loading">
                                {{ loading ? 'Bezig met opslaan...' : 'Opslaan' }}
                            </button>
                        </div>
                    </form>
                    
                    <div v-else class="modal-actions">
                        <button type="button" class="btn btn-primary" @click="$modal.close()">Sluiten</button>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import translations from "../../mixins/translations";
import Datepicker from 'vuejs-datepicker';
import {nl} from 'vuejs-datepicker/dist/locale';

export default {
    name: 'EditCustomerModal',

    components: {
        Datepicker
    },

    mixins: [translations],

    props: {
        userData: {
            type: Object,
            required: true
        }
    },

    data() {
        let birthDate = this.userData.Geboortedatum || '';
        
        // Als de datum een string is, probeer hem te converteren naar een Date object
        if (birthDate && typeof birthDate === 'string') {
            // Check voor DD-MM-YYYY formaat
            const match = birthDate.match(/^(\d{2})-(\d{2})-(\d{4})$/);
            if (match) {
                // Maand is 0-indexed in JS Date
                birthDate = new Date(parseInt(match[3]), parseInt(match[2]) - 1, parseInt(match[1]));
            } else {
                const dateAttempt = new Date(birthDate);
                if (!isNaN(dateAttempt.getTime())) {
                    birthDate = dateAttempt;
                }
            }
        }

        return {
            nl: nl,
            form: {
                Titel: this.userData.Titel || 'Dhr.',
                Voornaam: this.userData.Voornaam || '',
                Achternaam: this.userData.Achternaam || '',
                Geboortedatum: birthDate,
                Straat: this.userData.Straat || '',
                Huisnummer: this.userData.Huisnummer || '',
                Postcode: this.userData.Postcode || '',
                Stad: this.userData.Stad || '',
                Land: this.userData.Land || 'NL',
                Telefoon: this.userData.Telefoon || '',
                Nieuwsbrief: !!this.userData.Nieuwsbrief,
            },
            loading: false,
            successMessage: '',
            errorMessage: '',
        };
    },

    methods: {
        formatDate(date) {
            if (!date) return '';
            if (typeof date === 'string') {
                // Als het al een string is in DD-MM-YYYY formaat, geef het terug
                if (/^\d{2}-\d{2}-\d{4}$/.test(date)) {
                    return date;
                }
                date = new Date(date);
            }
            if (!(date instanceof Date) || isNaN(date)) return '';
            
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            
            return `${day}-${month}-${year}`;
        },

        handleSubmit() {
            this.loading = true;
            this.errorMessage = '';
            this.successMessage = '';

            const formData = { ...this.form };
            formData.Geboortedatum = this.formatDate(formData.Geboortedatum);

            window.axios.post('/api/customer/update-data', formData)
            .then(response => {
                this.successMessage = 'Uw gegevens zijn succesvol aangepast.';
                this.loading = false;
                this.$emit('data-updated');

                setTimeout(() => {
                    window.location.reload();
                }, 1500);
            })
            .catch(error => {
                this.errorMessage = error.response?.data?.error || 'Er is een fout opgetreden bij het opslaan.';
                this.loading = false;
            });
        }
    }
};
</script>

<style scoped>
.modal-title {
    margin: 0;
    font-size: 20px;
    color: #033239;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 0;
    padding-top: 1rem;
    font-weight: 600;
    color: #033239;
}

.form-control {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    margin-top: 32px;
}

.btn {
    padding: 12px 24px;
    border-radius: 4px;
    font-weight: 700;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;
    line-height: 1.5rem;
    font-size: 1rem;
    margin-top: 0;
}

.btn-primary {
    background: #82db39;
    border: 1px solid #82db39;
    color: #033239;
}

.btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-outline {
    background: transparent;
    border: 1px solid #ccc;
    color: #666;
}

.alert {
    padding: 12px;
    border-radius: 4px;
    margin-bottom: 20px;
}

.alert-success {
    background: #d4edda;
    color: #155724;
}

.alert-danger {
    background: #f8d7da;
    color: #721c24;
}

.custom-checkbox {
    padding-left: 0;
}

.custom-control-label {
    padding-top: 0 !important;
    font-weight: 400 !important;
    cursor: pointer;
}

.custom-control-input {
    width: 1.25rem;
    height: 1.25rem;
    margin-right: 0.5rem;
}
</style>
